import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=457b97d4"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457b97d4')) {
      api.createRecord('457b97d4', component.options)
    } else {
      api.reload('457b97d4', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=457b97d4", function () {
      api.rerender('457b97d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plugin/Confirm.vue"
export default component.exports